<template>
  <div class="box">
    <div style="position: relative;margin-top: 15px;">
      <div style="width: 1250px;height: 65px;margin: auto;">
        <div style="float: left;margin-top: -25px;">
          <img src="/static/images/logo4.png" width="188" height="91">
        </div>
        <div style="float: left;margin-left: 30px;">
          <img src="https://filewww.fspits.com//File/2023/0418/2023041804.jpg" width="278" height="53">
        </div>
        <div style="position: relative">

          <div style="position: absolute;right:0;width: 450px;height: 33px;border: 2px solid #FF8C00;border-radius:10px;">
            <input v-model="Keyword" type="text" id="Search_input_top"
                   style="padding:0;height: 33px;position: relative;border-radius: 10px;border:none;width: 450px;box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.3), 0 0 6px 2px rgba(0, 0, 0, 0.15);background-image: url('/static/images/search_pic.png')"
                   @keydown.enter="Head_GotoSearch" placeholder="输入您想出发的目的地">

            <div @click.stop="Head_GotoSearch"
                 style="border-radius: 0 9px 9px 0;background-color: #FF8C00;height: 33px;width: 55px;position: absolute;cursor: pointer;background-repeat:no-repeat;right: 0;top: 0;">
              <img src="/static/images/search_pic.png"></div>

            <ul style="position: absolute;list-style: none;margin: 0;font-size: 14px;padding-left: 1px;padding-top: 5px;cursor: pointer;color: #8E8E8E;"
                id="MainTopNavDivUL">
              <li style="float: left;margin-right: 8px;" v-for="o in HotKeyword" @click="utils.NavigationPage({path:'/Product/Search/',query:{Keyword:o}})">{{o}}</li>
            </ul>
          </div>

        </div>
      </div>
    </div>


    <div id="MainTopNavDiv">
      <ul>
        <li style="margin-right:30px;cursor: default;background-color: #fd9d05">
          <img src="/static/images/menu_p.png" style="position: relative;left:-15px;top:-2px;float: left;">
          <span style="display: block;width: 150px;font-size: 16px;">旅游目的地推荐</span>
        </li>
        <li @click="utils.NavigationPage({path:'/'})" v-if="$route.path !== '/'">
          <a>首页</a>
        </li>
        <li @click="utils.NavigationPage({path:'/RouteList/',query:{Dir:'zby'}})">
          <a>周边游</a>
        </li>
        <li @click="utils.NavigationPage({path:'/RouteList/',query:{Dir:'gny'}})">
          <a>国内游</a>
        </li>
        <!--<li @click="utils.NavigationPage({path:'/RouteList/',query:{Dir:'hwy'}})">
          <a>海外游</a>
        </li>-->
        <li @click="utils.NavigationPage({path:'/Template/Customized/'})">
          <a>私人定制旅游</a>
        </li>
        <li @click="utils.NavigationPage({path:'/Product/Search/',query:{IntoGroupState:1}})">
          <a>铁定出发</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: "AppHead",
    computed: {
      ...mapGetters([
        'HotKeyword'
      ])
    },
    data() {
      return {
        Keyword: ''
      };
    },
    created() {
    },
    methods: {
      Head_GotoSearch() {
        this.utils.NavigationPage({path: '/Product/Search/', query: {'Keyword': this.Keyword}});
      },

    }
  }
</script>

<style scoped lang="scss">


  .box {
    padding: 0;
    margin: 0;
    width: 100%;
    position: relative;
    text-align: center;


    #MainTopNavDiv {
      width: 100%;
      height: 38px;
      position: relative;
      background-color: #fd9d05;
      display: block;
      margin: auto;

      ul {
        width: $float-container-width;
        margin: auto;
        list-style-type: none;
        padding-top: 10px;

        li {
          float: left;
          margin-right: 30px;
          font-size: 16px;
          color: #fff;

          a {
            display: block;
            float: left;
            cursor: pointer;
            transition: 0.4s;

            &:hover {
              color: #642100;
            }
          }
        }
      }

    }
  }




</style>



// WEBPACK FOOTER //
// src/layout/components/AppHead.vue